<template>
  <div class="list-box">
    <table>
      <thead>
        <tr>
          <th :class="['sortable', {'active':currentOrder.field === 'code'}]" @click="sort('code')">
            Code
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'code'"></i>
          </th>
          <th :class="['sortable', {'active':currentOrder.field === 'amount'}]" @click="sort('amount')">
            Amount
             <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'amount'"></i>
          </th>
          <th :class="['sortable', {'active':currentOrder.field === 'id'}]" @click="sort('id')">
            Created Date
             <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'id'"></i>
          </th>
          <th :class="['sortable', {'active':currentOrder.field === 'startUTC'}]" @click="sort('startUTC')">
            Start Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'startUTC'"></i>
          </th>
          <th :class="['sortable', {'active':currentOrder.field === 'endUTC'}]" @click="sort('endUTC')">
            End Date
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'endUTC'"></i>
          </th>
          <th>Widget</th>
          <th>App</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in discountCodes.list" :key="i">
          <td>
            <a :href="`#/discount-codes/${data.id}`">{{data.code}}</a>
          </td>
          <td>{{data.amount}}</td>
          <td>{{data.created}}</td>
          <td>{{data.start}}</td>
          <td>{{data.end}}</td>
          <td>
            <div :class="['status', {enabled:data.enabled}]" @click="update(data.id, !data.enabled, 'widget')">
              <i class="fas fa-spinner fa-spin" v-if="widgetLoading.indexOf(data.id) > -1"></i>
              <span v-else>{{data.enabled ? 'Enabled' : 'Disabled'}}</span>
            </div>
          </td>
          <td>
            <div :class="['status', {enabled:data.appEnabled}]" @click="update(data.id, !data.appEnabled, 'app')">
              <i class="fas fa-spinner fa-spin" v-if="appLoading.indexOf(data.id) > -1"></i>
              <span v-else>{{data.appEnabled ? 'Enabled' : 'Disabled'}}</span>
            </div>
          </td>
          <td>
            <a :class="['button cta xsmall success', {disabled: exportLoading.indexOf(data.id) > -1}]" @click="exportDC(data)">
              <span v-if="exportLoading.indexOf(data.id) > -1">
                Loading
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span v-else>Export</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="cards">
      <div class="card" v-for="(data, i) in discountCodes.list" :key="i">
        <div class="card-info">
          <div class="card-header">
            <div class="title">
              <!-- <span class="name">{{data.code}}</span> -->
              <a :href="`#/discount-codes/${data.id}`">{{data.code}}</a>
            </div>
            <div class="amount">
              <span class="amount">{{ data.amount }}</span>
            </div>
          </div>
          <div class="title">
            <div class="label">Created Date: </div>
            <div class="value">{{data.created}}</div>
          </div>
          <div class="title">
            <div class="label">Start Date: </div>
            <div class="value">{{data.start}}</div>
          </div>
          <div class="title">
            <div class="label">End Date: </div>
            <div class="value">{{data.end}}</div>
          </div>
        </div>
        <div class="widget-app">
          <div class="widget">
            <span>Widget</span>
            <div :class="['status', {enabled:data.enabled}]" @click="update(data.id, !data.enabled, 'widget')">
              <i class="fas fa-spinner fa-spin" v-if="widgetLoading.indexOf(data.id) > -1"></i>
              <span v-else>{{data.enabled ? 'Enabled' : 'Disabled'}}</span>
            </div>
          </div>
          <div class="app">
            <span>App</span>
            <div :class="['status', {enabled:data.appEnabled}]" @click="update(data.id, !data.appEnabled, 'app')">
              <i class="fas fa-spinner fa-spin" v-if="appLoading.indexOf(data.id) > -1"></i>
              <span v-else>{{data.appEnabled ? 'Enabled' : 'Disabled'}}</span>
            </div>
          </div>
        </div>
        <div class="actions">
          <span v-if="exportLoading.indexOf(data.id) > -1">
              Loading
              <i class="fas fa-spinner fa-spin"></i>
          </span>
          <a class="button cta xsmall success" @click="exportDC(data)" v-else>Export</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CsvExport from 'csvexport'
import moment from 'moment-timezone'

const exporter = CsvExport.create({
  filename: 'discount-code-export.csv',
  columns: [ 'RSVP ID', 'Created', 'Discount Amount' ]
})

export default {
  name: 'discount-code-list',
  data () {
    return {
      widgetLoading: [],
      appLoading: [],
      exportLoading: []
    }
  },
  computed: {
    discountCodes () { return this.$store.state.discountCodes },
    currentOrder () {
      let dc = this.discountCodes
      return { field: dc.order, asc: dc.orderAsc }
    },
    loading: {
      get () { return this.discountCodes.loading },
      set (x) { this.$store.commit('discountCodes/setListData', {loading: x}) }
    },
  },
  methods: {
    sort (field) {
      let self = this
      if (self.loading) { return }
      if (field !== self.discountCodes.order) {
        self.$store.commit('discountCodes/setListData', {orderAsc: 1})
      } else {
        self.$store.commit('discountCodes/setListData', {orderAsc: self.discountCodes.orderAsc === 1 ? '' : 1})
      }
      self.$store.commit('discountCodes/setListData', {order: field})

      self.$emit('search')
    },
    update (id, val, type) {
      let self = this
      if (self[`${type}Loading`].indexOf(id) > -1) return
      self[`${type}Loading`].push(id)

      let param = { token: self.$store.state.session.sessionToken }
      param[type === 'app' ? 'isApp' : 'isWidget'] = val
      self.$sdk.post(`/discountcode/${id}`, param, res => {
        self[`${type}Loading`].splice(self[`${type}Loading`].indexOf(id), 1)

        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }

        if (res.success) {
          let field = {}
          field[type === 'app' ? 'appEnabled' : 'enabled'] = val
          self.$store.commit('discountCodes/updateListData', {
            id: id,
            fields: field
          })
        }
      })
    },
    exportDC (dc) {
      let self = this
      if (self.exportLoading.indexOf(dc.id) > -1) return
      self.exportLoading.push(dc.id)

      self.$sdk.get(`/discountcode/${dc.id}/usage`, {
        token: self.$store.state.session.sessionToken,
      }, res => {
        let i = self.exportLoading.indexOf(dc.id)
        if (i > -1) self.exportLoading.splice(i, 1)

        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        if (!res.list.length) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `<b>${dc.code}</b> Empty data.`
          })
          return
        }

        let list = []
        res.list.forEach(data => {
          list.push({
            'RSVP ID': data.rsvpId,
            'Created': moment(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
            'Discount Amount': `$${data.discountAmount.toFixed(2)}`
          })
        })
        exporter.downloadCsv(list)
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.list-box{
  overflow-y: auto;
  height: calc(100vh - 50px);

  thead {
    color: #8DA0A9;
    font-size: 12px;

    th {
      border-bottom: 1px solid #ccc;
      background-color: #f5f5f5;
      position: sticky;
      top: 0px;
    }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding: 5px;
  text-align: center;
}
tr{
  border-bottom: 1px solid #ddd;

  &:nth-child(even){
    background: #fbfbfb;
  }
  td{
    font-size: 14px;
    padding: 8px 5px;
  }
}
.status{
  font-size: 13px;
  color: #999;
  cursor: pointer;
  text-decoration: underline;
  text-transform: uppercase;
  font-weight: 600;

  &.enabled{
    color: #33b219;
  }
  i{
    color: #3e7dbf;
    font-size: 18px;
  }
}

.cards {
  display: none;
}

@media only screen and (max-width: 430px) {
  .list-box {
    table {
      display: none;
    }

    .cards {
      display: block;
      padding-bottom: 75px;
      margin-top: 20px;
      .card {
        border: 1px solid #ccc;
        margin: 0 10px;
        margin-bottom: 15px;
        border-bottom: 5px solid #aaa9;
        border-radius: 10px;

        > div {
          margin-bottom: 3px;
        }

        .card-info {
          padding: 12px;
          padding-bottom: 0;
    
          .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
            .name {
              font-weight: 900;
            }
            .amount {
              margin-left: 5px;
              font-weight: 900;
              font-size: 16px;
            }
            .status {
              text-transform: uppercase;
              font-size: 14px;
              font-weight: 900;
            }
          }
    
          .title {
            display: flex;
            align-items: center;

            a { font-weight: 900; }
          }
    
          .label {
            font-size: 12px;
            text-transform: uppercase;
            color: #bbb;
            font-weight: 600;
            margin-right: 5px;
          }
    
          .value {
            margin-right: 10px;
            font-size: 14px;
            font-weight: 900;
          }
        
        }

        .widget-app {
          display: flex;
          margin-bottom: 0;
          margin-top: 10px;

          .widget, .app {
            background-color: #f4f8f9;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 7px;
            border: 1px solid #eee;

            span {
              font-size: 12px;
              text-transform: uppercase;
              font-weight: 900;
            }

            .status {
              span {
                font-size: 14px;
              }
            }
          }
        }
        .actions {
          width: 100%;
          background: #f3f3f3;
          border-top: 1px solid #ccc;
          padding: 15px 10px;
          text-align: center;
          border-radius: 0 0 10px 10px;
          margin-bottom: 0;
          .button {
            line-height: 14px;
            font-size: 14px;
            padding: 10px 18px 9px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DiscountCodes/List.vue